import { FC } from "react";
import "./loading.css";

export const Loading: FC = () => {
	return (
		<div className="loading">
			<div className="lds-dual-ring"></div>
		</div>
	);
};

export default Loading;
